import { render } from "./AdminZiarat.vue?vue&type=template&id=22f8cf45"
import script from "./AdminZiarat.vue?vue&type=script&lang=js"
export * from "./AdminZiarat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__